<script>
  import { getLoggedIn, getCartCount, getAccessibilityRedesignRenderState } from '../../../../../../../js/stores';
  import { filterNavItems } from '../../../../../../../js/navItemFilters';
  import { trackLinkClick } from '../../../../../../../js/trackLinkClick';

  // Constants
  const loggedInStore = getLoggedIn();
  const cartCountStore = getCartCount();
  const accessibilityRedesignRenderStore = getAccessibilityRedesignRenderState();

  // Props
  export let id = undefined;
  export let title = undefined;
  export let navItems = [];

  // Filter out any items that should be hidden
  $: filteredItems = filterNavItems({
    items: navItems,
    loggedIn: $loggedInStore,
    cartCount: $cartCountStore,
  });

  // Subcategory items should only be of type 'link'
  $: linkItems = filteredItems.filter((item) => item.type === 'link');
</script>

<div {id} class="SubcategoryFlattened" data-subcategory={title}>
  <span class="subcategory-title" role="heading" aria-level="2">{title}</span>
  <ul class="subcategory-links">
    {#each linkItems as item}
      <li>
        <a
          class="subcategory-link"
          class:focus-highlight={!$accessibilityRedesignRenderStore}
          class:focus-accessibility-redesign={$accessibilityRedesignRenderStore}
          id={item.id}
          href={item.url}
          use:trackLinkClick={{
            id: item.id,
            title: item.title,
            url: item.url,
          }}
        >
          <span
            class:subcategory-link-title={!$accessibilityRedesignRenderStore}
            class:subcategory-link-title-accessibility-redesign={$accessibilityRedesignRenderStore}
          >
            {item.title}
          </span>
        </a>
      </li>
    {/each}
  </ul>
</div>

<style>@charset "UTF-8";
.SubcategoryFlattened {
  padding: 0;
}

.subcategory-title {
  font-weight: var(--font-weight-medium, 500);
  text-transform: uppercase;
  letter-spacing: 0.125em;
  font-family: "Square Sans Text VF", "Square Sans Text", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", meiryo, "ＭＳ Ｐゴシック", sans-serif;
  font-size: 14px;
  line-height: 22px;
  display: block;
  margin-left: 8px;
  margin-bottom: 24px;
  width: max-content;
  color: var(--color-gray, #737373);
}

.subcategory-links {
  display: block;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.subcategory-links > li {
  display: block;
  position: static;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.subcategory-links > li::before {
  display: none;
}

.subcategory-link {
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  display: inline-block;
  vertical-align: top;
  overflow: hidden;
  position: relative;
  min-height: 0;
  max-height: none;
  margin: 0;
  padding: 8px;
  border-radius: 6px;
  border: 0;
  outline: 0;
  color: var(--color-text, #1a1a1a);
  background-color: transparent;
  font-family: "Square Sans Text VF", "Square Sans Text", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", meiryo, "ＭＳ Ｐゴシック", sans-serif;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: normal;
  text-align: left;
  text-decoration: none;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
}

.subcategory-link-title {
  display: block;
  position: relative;
  font-size: 16px;
  line-height: 28px;
  font-weight: var(--font-weight-medium, 500);
}

.subcategory-link-title-accessibility-redesign {
  display: inline;
  padding-bottom: 3px;
  font-size: 16px;
  line-height: 28px;
  font-weight: var(--font-weight-medium, 500);
}

.focus-highlight {
  position: relative;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
}
.focus-highlight::-moz-focus-inner {
  border: 0;
}
.focus-highlight:focus {
  outline: none;
}
.focus-highlight::before {
  content: "";
  pointer-events: none;
  display: block;
  position: absolute;
  inset: 0;
  background-color: var(--color-highlight, rgba(26, 26, 26, 0.1));
  border-radius: 0;
  opacity: 0;
  transition: opacity 100ms cubic-bezier(0.4, 0, 0.2, 1), transform 100ms cubic-bezier(0.4, 0, 0.2, 1);
  transform: scale(0);
}
.focus-highlight:focus:not(:active)::before {
  opacity: 1;
  transform: scale(1);
}
@media (hover: hover) {
  .focus-highlight:hover::before {
    opacity: 1;
    transform: scale(1);
  }
}
.focus-highlight > * {
  position: relative;
}

.focus-accessibility-redesign:focus-visible:not(:active) {
  outline-offset: 2px;
  outline: 2px auto Highlight;
  outline: 2px auto -webkit-focus-ring-color;
}
.focus-accessibility-redesign span {
  background-image: linear-gradient(var(--color-text), var(--color-text));
  background-size: 0% 1.5px;
  background-repeat: no-repeat;
  background-position: calc(100% - 0px) calc(100% - 1.5px);
  transition: background-size 250ms cubic-bezier(0.4, 0, 0.2, 1);
}
@media (hover: hover) {
  .focus-accessibility-redesign:hover span {
    background-position: calc(0% + 0px) calc(100% - 1.5px);
    background-size: calc(100% - 0px) 1.5px;
  }
}</style>
